import { render } from "./IppsuCard.vue?vue&type=template&id=4ed1beb7&scoped=true"
import script from "./IppsuCard.vue?vue&type=script&lang=js"
export * from "./IppsuCard.vue?vue&type=script&lang=js"

import "./IppsuCard.vue?vue&type=style&index=0&id=4ed1beb7&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed1beb7"]])

export default __exports__